import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '$setup/redux'

export function createUseEntity<E>(
  getView: (id: string) => (state: RootState) => E,
  getEntityAsync: (id: string) => Promise<E>,
) {
  return function(id: string) {
    const entity: E = useSelector(getView(id))
    const [err, setErr] = useState(null)

    useEffect(() => {
      if (entity) return
      getEntityAsync(id).catch(setErr)
    }, [entity, id])

    // TODO: Think about merging logic in react component
    if (err) return { err }
    if (!entity) return { loading: true }

    return { entity }
  }
}
